import React from 'react';
import InputRange from 'react-input-range';

const PageFour = (props) => {
  return (
    <div className="kids-quiz__page">
      <div className="kids-quiz__question">
        <p className="question__title">How is {props.kidsName} feeling lately?</p>
        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.energySliderValue}
            onChange={value => props.handleSlider(value, 'energy')}
          />
          <div className="range__text">
            <p>Really tired</p>
            <p>Full of beans</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.activitySliderValue}
            onChange={value => props.handleSlider(value, 'activity')}
          />
          <div className="range__text">
            <p>Not very active</p>
            <p>Can run for miles</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.sleepSliderValue}
            onChange={value => props.handleSlider(value, 'sleep')}
          />
          <div className="range__text">
            <p>Sleepless nights</p>
            <p>Sleeps like a baby</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.screenSliderValue}
            onChange={value => props.handleSlider(value, 'screen')}
          />
          <div className="range__text">
            <p>Rarely online</p>
            <p>Screen junkie</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.attentionSliderValue}
            onChange={value => props.handleSlider(value, 'attention')}
          />
          <div className="range__text">
            <p>Easily distracted</p>
            <p>Always focused</p>
          </div>
        </div>
      </div>
      <div className="next-page" onClick={() => props.nextPage('4')}>Continue</div>
    </div>
  );
}

export default PageFour;